<app-modal
  [show]="show"
  title="Switch user"
  [confirm]="false"
  closeButtonLabel="Cancel"
  [tall]="true"
  (onClose)="onClose.emit()"
>
  <p class="mb-4">
    Sign in as any user to test what they see. You can switch back to your own account from the banner at the top of
    every page.
  </p>

  <div class="mb-4">
    <app-text-input
      [control]="searchControl"
      [name]="'switch_user_search'"
      placeholder="Search by name, email, role or event status"
    ></app-text-input>
  </div>

  @if (error) {
    <p class="mb-4 rounded-lg bg-error-50 px-4 py-3 text-error-700 dark:bg-error-500/15 dark:text-error-400">{{ error }}</p>
  }

  @if (loading) {
    <p class="py-6 text-center">Loading users…</p>
  } @else {
    <ul class="divide-y divide-gray-100 dark:divide-gray-800">
      @for (user of filteredUsers; track user.id) {
        <li>
          <button
            type="button"
            class="flex w-full flex-col gap-2 rounded-lg px-3 py-3 text-left hover:bg-gray-50 disabled:opacity-50 sm:flex-row sm:items-center sm:justify-between dark:hover:bg-white/5"
            [disabled]="switchingToId !== null"
            (click)="switchTo(user)"
          >
            <span class="min-w-0">
              <span class="block truncate font-medium text-gray-800 dark:text-white/90">{{ user.name }}</span>
              <span class="block truncate text-theme-xs text-gray-500 dark:text-gray-400">{{ user.email }}</span>
            </span>
            <span class="flex flex-wrap items-center gap-1.5 sm:justify-end">
              <span
                class="inline-flex items-center rounded-full bg-brand-100 px-2.5 py-1 text-theme-xs font-medium text-brand-800 dark:bg-brand-500/20 dark:text-brand-300"
              >
                {{ roleLabel(user.role) }}
              </span>
              @if (user.role === 'customer') {
                @for (event of user.events; track event.id) {
                  <span
                    class="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-1 text-theme-xs font-medium text-gray-700 dark:bg-white/5 dark:text-gray-300"
                    [title]="event.reference ?? ''"
                  >
                    {{ event.status }}
                  </span>
                } @empty {
                  <span class="text-theme-xs text-gray-400">No events</span>
                }
              }
              @if (switchingToId === user.id) {
                <span class="text-theme-xs text-gray-500">Switching…</span>
              }
            </span>
          </button>
        </li>
      } @empty {
        <li class="py-6 text-center">No users match your search.</li>
      }
    </ul>
  }
</app-modal>
